import Logo from './logo.svg';
import BuildingImg from './building.svg';
import ProfileImg from './profile-img.png';

export { 
    Logo, 
    BuildingImg,
    ProfileImg,
}; 